import dayjs from "dayjs";
import { Table, Tabs } from "antd";
import { StaffFinanceSettingsContainerBlobFinanceConfigFieldsFragment, StaffFinanceSettingsContainerBlobFinancialConfigFieldsFragment } from "../../../../generated";
import { ApplicationTypeEnum } from "./finance-settings.enum";
import type { TableColumnsType } from 'antd';
import { FormatDate } from '../../../../constants';


// Mapping for application type display names
const applicationTypeLabels = {
  [ApplicationTypeEnum.IdCase]: "ID Case",
  [ApplicationTypeEnum.CredentialVerificationCase]: "Credential Verification Case",
  [ApplicationTypeEnum.SendReportCase]: "Send Report Case",
};

interface FinanceSettingsListProps {
  data: StaffFinanceSettingsContainerBlobFinancialConfigFieldsFragment[];
  selectedRecord: StaffFinanceSettingsContainerBlobFinanceConfigFieldsFragment | null;
  currentPage: number;
  activeTab: ApplicationTypeEnum;
  onTabChange: (key: string) => void;
  onRowSelect: (id: string) => void;
}

export const FinanceSettingsList: React.FC<FinanceSettingsListProps> = (props) => {
  const columns: TableColumnsType<StaffFinanceSettingsContainerBlobFinancialConfigFieldsFragment> = [
    {
      title: "Effective Date",
      dataIndex: "effectiveAt",
      key: "effectiveAt",
      render: (date: string | number | Date | dayjs.Dayjs | null | undefined) => FormatDate(date ? date.toString() : undefined),
    },
    {
      title: "Rule Name",
      dataIndex: "ruleName",
      key: "ruleName",
    },
    {
      title: "Version",
      dataIndex: "version",
      key: "version",
    },
  ];

  const recordsPerPage = 5;
  const dataSource = props.data.filter((record) => record.caseType?.includes(props.activeTab)).slice((props.currentPage - 1) * recordsPerPage, props.currentPage * recordsPerPage);
  const tabItems = Object.keys(applicationTypeLabels).map((appType) => ({
    key: appType,
    label: applicationTypeLabels[appType as ApplicationTypeEnum],
    children: (
      <div>
        <Table
          rowHoverable={false}
          columns={columns}
          dataSource={dataSource}
          pagination={false}
          className="w-full border border-[#f0f0f0] rounded-[10px] p-[15px] max-w-full border-solid"
          onRow={(record) => ({
            onClick: () => {
              if (record.id) {
                props.onRowSelect(record.id);
              }
            },
          })}
          rowClassName={(record) => (record.effectiveAt === props.selectedRecord?.effectiveAt ? "ant-table-row-selected" : "")}
          rowKey="id"
        />
      </div>
    ),
  }));

  return (
    <div>
      <Tabs
        activeKey={props.activeTab}
        onChange={(key) => {
          props.onTabChange(key);
        }}
        items={tabItems}
      />
    </div>
  );
};
